module.exports = __webpack_public_path__ + "img/LandMarket.42dc8752.png";